import { findByKey } from '../helpers/index'

const permissionsPlugin = {
  install (Vue, options) {

    Vue.prototype.$canDo = function(action) {
      if (this.$user.partner_id === 0) {
        return true
      } else if (action === 'permissions') {
        return false
      }

      const permissions = this.$user.permissions

      if (permissions) {
        const permission = findByKey(permissions, action)

        if (_.isNull(permission) || _.isUndefined(permission)) { //permission not set
          return true
        }

        if (_.isObject(permission)) {
          return permission.visible
        } else {
          return permission
        }

      } else {
        return false
      }
    }

    Vue.prototype.$canDoStrict = function(action) {
      if (this.$user.partner_id === 0) {
        return true
      }
      if (action === 'super') {
        return false
      }

      const permissions = this.$user.permissions

      if (permissions) {
        const permission = findByKey(permissions, action)

        if (_.isObject(permission)) {
          return permission.visible
        } else {
          return permission
        }

      } else {
        return false
      }
    }

    Vue.prototype.$canUserDo = function(action) {
      // if (this.$user.partner_id === 0) {
      //   return true
      // }
      // if (action === 'super') {
      //   return false
      // }

      const permissions = this.$user_sso_permissions;

      if (permissions) {
        const isAllowed = permissions.includes(action);
        
        return isAllowed;
      } else {
        return false
      }
    }
  }
}

export default permissionsPlugin




// WEBPACK FOOTER //
// ./src/plugins/permissions.js